import { PRELOAD_BUNDLE_IMAGES_SUCCESS, PRELOAD_BUNDLE_IMAGES_ERROR } from "../../../frontend/instant-images-preloader";

import { START_FETCHING, STOP_FETCHING } from "../Actions/ActionProcessing";

const initialState = {
  counter: 0,
  text: void 0
};

export const fetchingCounter = (state = initialState, action) => {
  let newState = null;
  switch (action.type) {
    case START_FETCHING:
      return {
        counter: state.counter + 1,
        text: action.text || state.text
      };
    case PRELOAD_BUNDLE_IMAGES_SUCCESS:case PRELOAD_BUNDLE_IMAGES_ERROR:case STOP_FETCHING:
      newState = Object.assign({}, state);
      newState.counter = newState.counter > 0 ? --newState.counter : 0;
      newState.text = action.text === state.text || newState.counter === 0 ? void 0 : state.text;
      return newState;
    default:
      return state;

  }
};